module.exports = __webpack_public_path__ + "static/media/ABC National Logo.77d125f7.jpeg";